export default "__VITE_ASSET__CXj5UoW8__"